import { render } from "./VatTuTable.vue?vue&type=template&id=587b6291&ts=true"
import script from "./VatTuTable.vue?vue&type=script&lang=ts"
export * from "./VatTuTable.vue?vue&type=script&lang=ts"

import "./VatTuTable.vue?vue&type=style&index=0&id=587b6291&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__